/* eslint-disable jira/filename-case */
export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4Dashboards';
export const TEAM_NAME = 'jira-cosmos';

export const VIEW_ALL_DASHBOARDS = 'viewAllDashboards';

export const CREATE_DASHBOARD = 'createDashboard';
export const MEATBALL_DROPDOWN = 'meatballDropdown';

export type FixButtonTypeId = typeof CREATE_DASHBOARD | typeof MEATBALL_DROPDOWN;
